import {NJReqIndividualWinView} from "./NJReqIndividualWinView";
import {LayoutDimData} from "../../../../../core/utils/ResizeHelper";
import {PREngineManager} from "../../../../punkEngine/PREngineManager";

export class PRFadedWinView extends PIXI.Container {
    private bottomTrainVisible: boolean = false;

    constructor() {
        super();
        this.name = "PRFadedWinView";
        this.init();
    }

    public addWinWays(winWaysObj: NJReqIndividualWinView): void {
        this.addChild(winWaysObj);
    }

    public removeWinWays(winWaysObj: NJReqIndividualWinView): void {
        this.removeChild(winWaysObj);
    }

    onResize(): void {
        const scaledReelDim: LayoutDimData = this.bottomTrainVisible ? PREngineManager.dimScaled : PREngineManager.dim;

        this.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
        this.position.set(scaledReelDim.position.x, scaledReelDim.position.y);
    }

    public onBottomTrainShow(flag: boolean, isRestore: boolean = false): void {
        this.bottomTrainVisible = flag;
        this.onResize();
    }

    private init(): void {
        this.position.set(0, 180);
        this.onResize();
    }
}